import { UsersIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Users = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <UsersIcon {...rest} size={Sizes[size]} color={fill} />;
};

Users.displayName = 'Users';
